import { generateMemberUrl } from "@routes/app";
import { MemberType } from "next-lib";
import { Link } from "react-router-dom";

type Props = {
  member: MemberType;
  memberImage: any;
};

function Member({ member, memberImage }: Props) {
  return (
    <Link
      className="grid w-full md:min-w-[8rem] min-w-[5rem] md:min-h-[15rem] min-h-[8rem] h-full transform cursor-pointer place-items-center rounded-xl border border-blue-gray-50 bg-white transition-all hover:scale-105 hover:border-blue-gray-100 hover:bg-blue-gray-50 hover:bg-opacity-25"
      to={generateMemberUrl(member)}
      style={{
        background: `url("${memberImage[member.firstName.toLowerCase()]}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <span className="my-6 grid h-full w-full rounded-xl place-items-center bg-[rgba(0,0,0,.5)] hover:bg-[rgba(0,0,0,.2)]">
        <p className="text-white text-xl font-bold">{member.firstName}</p>
      </span>
    </Link>
  );
}

export default Member;
